import apiClient from './client';

export interface BrandStatistic {
  brand: string;
  count: number;
  totalValue: number;
}

export interface CustomerCityStatistic {
  city: string;
  count: number;
}

export interface SalesSummary {
  totalSales: number;
  totalRevenue: number;
  averageSaleValue: number;
}

export interface RepairStatusStatistic {
  status: string;
  count: number;
}

export interface RevenueStatistic {
  period: string;
  revenue: number;
  expenses: number;
  profit: number;
}

export interface DepartmentStatistic {
  departmentId: string;
  departmentName: string;
  deviceCount: number;
  pcCount: number;
}

export interface CompanyStatistic {
  companyId: string;
  companyName: string;
  totalDevices: number;
  percentage: number;
}

export interface CategoryStatistic {
  categoryId: string;
  categoryName: string;
  totalDevices: number;
  percentage: number;
}

export const statisticsApi = {
  getBrands: async (): Promise<BrandStatistic[]> => {
    const response = await apiClient.get('/statistics/brands');
    return response.data;
  },

  getCustomersByCity: async (): Promise<CustomerCityStatistic[]> => {
    const response = await apiClient.get('/statistics/customers-by-city');
    return response.data;
  },

  getSalesSummary: async (): Promise<SalesSummary> => {
    const response = await apiClient.get('/statistics/sales-summary');
    return response.data;
  },

  getRepairStatus: async (): Promise<RepairStatusStatistic[]> => {
    const response = await apiClient.get('/statistics/repair-status');
    return response.data;
  },

  getRevenue: async (): Promise<RevenueStatistic[]> => {
    const response = await apiClient.get('/statistics/revenue');
    return response.data;
  },

  getDevicesByDepartment: async (branchId?: string): Promise<DepartmentStatistic[]> => {
    const params = branchId ? { branchId } : {};
    const response = await apiClient.get('/statistics/devices-by-department', { params });
    return response.data;
  },

  getDevicesByCompany: async (branchId?: string): Promise<CompanyStatistic[]> => {
    const params = branchId ? { branchId } : {};
    const response = await apiClient.get('/statistics/devices-by-company', { params });
    return response.data;
  },

  getPCCountByDepartment: async (branchId?: string): Promise<DepartmentStatistic[]> => {
    const params = branchId ? { branchId } : {};
    const response = await apiClient.get('/statistics/pc-count-by-department', { params });
    return response.data;
  },

  getDevicesByCategory: async (branchId?: string): Promise<CategoryStatistic[]> => {
    const params = branchId ? { branchId } : {};
    const response = await apiClient.get('/statistics/devices-by-category', { params });
    return response.data;
  },
};
